<i18n lang='yml' src='../i18n/TrainingStandardIndex.yml'></i18n>
<template>
  <tabs :locale="locale" :tab_objects="[{name: programStandardTab, path: createProgramStandardPath(), active: false},
                                        {name: trainingStandardName, path: '#', active: true}]">
    <div>
      <div class="action-bar">
        <a class="btn btn-sm btn-success ml-auto mb-4" :href="createNewPath()">
          <font-awesome-icon :icon="['fas', 'plus']"/>
          {{ $t('new_training_standard') }}
        </a>
      </div>
    
      <filter-bar v-if="filterParams" :filter_params="filterParams" :filter_path="createTrainingStandardsPath()"/>

      <div class="alert alert-danger" role="alert" v-if="error">
        {{$t('loading_error') }}
      </div>
      
      <div v-else-if="trainingStandards.length == 0">
        <div class="alert alert-warning" role="alert">
          {{noDataError}}
        </div>
      </div>

      <div class="media-list has-dropdown">
        <div class="content-block" v-for="item in trainingStandards" :key="item.id">     
          <div class="post-meta">
            <ul class="list-inline list-annotation">
              <li>
                <h5 class="container-item-name">
                  <a :href="createSkillSetPath(item.id)"> {{ item.trade_code }} {{ item.version }} </a>
                </h5>
              </li>
              <li class="ml-auto">
                <div class="btn-group btn-group-sm ml-auto" role="group">
                  <a class="btn btn-outline-primary" :href="createEditPath(item.id)">
                    <font-awesome-icon :icon="['fas', 'edit']"/>
                    <span> {{ $t('edit') }} </span>
                  </a>
                  <a class="btn btn-outline-primary" v-if="item.network_terms_of_service" :href="createEditTOSPath(item.id, item.network_terms_of_service.id)">
                    {{ $t('dropdown.manage_terms_of_service') }}
                  </a>
                  <a class="btn btn-outline-primary" v-else :href="createNewTOSPath(item.id)">
                    {{ $t('dropdown.manage_terms_of_service') }}
                  </a>
                  <a class="btn btn-outline-primary" :href="createResourcePath(item.id)">
                    {{ $t('dropdown.manage_resources') }}
                  </a>
                </div>
              </li>
            </ul> 
          </div> 
          <div class="post-meta">
            <ul class="list-unstyled list-inline list-annotation">
              <li>
                <font-awesome-icon :icon="['far', 'clock']"/>
                <span :title="$t('last_updated')"> {{ formatDate(item.updated_at) }} </span>
              </li>
              <li >
                <font-awesome-icon :icon="['fas', 'check']" v-if="item.active"/>              
                <font-awesome-icon :icon="['fas', 'times']"  v-else />
                {{ item.training_standard_status.name[locale] }}
              </li>
            </ul>
          </div>
        </div> 
          <pagination 
            :page_count="trainingStandardPageCount" :expansion_threshold="expansion_threshold"
          />
      </div>
    </div>
  </tabs>
</template>

<script>
  import Main from '../../../../filter_bar/components/Main.vue';
  import Tabs from './TrainingProgramTabs.vue'
  import pagination from '../../../../shared/pagination/Pagination.vue';
  import {formatDate} from '../../../../shared/typescripts/dates.ts'
  
  export default { 
    props: [
      'locale',
      'training_standards',
      'training_standards_page_count',
      'base_path',
      'filter_params',
      'expansion_threshold'
    ],
    components: {
      'filter-bar': Main,
      'tabs': Tabs,
       pagination,
    },
    data() {
      return {
        loading: false,
        trainingStandards: [],
        filterParams: null,
        programStandardTab: this.$i18n.t('program_standard_label'),
        trainingStandardName: this.$i18n.t('training_standard_label'),
        error: false,
        examTab: this.$i18n.t('exam_label'),
        trainingStandardPageCount: Number(this.training_standards_page_count),
      }
    },
    mounted() {
     this.$i18n.locale = this.locale;
      try{
        this.trainingStandards = JSON.parse(this.training_standards)['items']
      }
      catch(err) {
        this.error = true;  
      }    
      this.filterParams = this.filter_params
    },
    computed: {
      noDataError: function() {
        let params = this.filterParams;
        try {
          if (params){
            return params['search'].value ? this.$t('no_search') : this.$t('no_data') ;
          }
        }
        catch(err) {
          this.error = true;  
        }    
      },
    },

    methods: {
      /// - Formatting - ///
      formatDate(dateString) {
        return formatDate(dateString)
      },

      /// - Paths - ///

      createNewPath(){
        let newPath = `${this.createTrainingStandardsPath()}/new`;
        return newPath;
      },

      createEditPath(id){
        let editPath = `${this.createTrainingStandardsPath()}/${id}/edit`;
        return editPath;
      },

      createNewTOSPath(id){
        let tosPath = `${this.createTrainingStandardsPath()}/${id}/training_standard_terms_of_services/new`;
        return tosPath;
      },

      createEditTOSPath(id, tosId){
        let tosPath = `${this.createTrainingStandardsPath()}/${id}/training_standard_terms_of_services/${tosId}/edit`;
        return tosPath;
      },

      createResourcePath(id){
        let resourcePath = `${this.createTrainingStandardsPath()}/${id}/training_standard_resources`;
        return resourcePath;
      },

      createSkillSetPath(id){
        let skillsetPath = `${this.createTrainingStandardsPath()}/${id}/skill_sets`;
        return skillsetPath;
      },

      createTrainingStandardsPath(){
        let path = `${this.base_path}/training_standards`
        return path;
      },

      createProgramStandardPath(){
        let path =`${this.base_path}/program_standards`
        return path;
      },
    },
  }
  
</script>
